import React, { useEffect, useState } from "react"
import "./styles.css"

const TextArea = ({ placeholder=undefined, onChange, className = "", initValue="" }) => {
	const defaultClass = `w-100 ${className}`
	const [renderedClassList, setRenderedClassList] = useState(defaultClass)
	const [value, setValue] = useState(initValue);
	const focusClass = "focus-input";
	const hasValueClass = "has-value";
	const blur = (e) => {
		const hasValue = value.length
		const removedFocusClass = renderedClassList.replace(`${focusClass} `, "")

		const newClassName = hasValue ? removedFocusClass : defaultClass
		setRenderedClassList(newClassName);
	}

	const focus = () => {
		setRenderedClassList(`${hasValueClass} ${focusClass} ${renderedClassList}`);
	}

	const targetValue = (e) => {
		setValue(e.target.value);
		onChange(e.target.value);
	}

	useEffect(() => {
		setValue(initValue)
	}, [initValue])
	return (
		<div className="input-block mt-3">
			<textarea
				rows={4}
				value={value}
				className={renderedClassList}
				onChange={targetValue}
				onBlur={blur}
				onFocus={focus}
			>
			</textarea>
			{placeholder && <span className="textarea-placeholder">{placeholder}</span>}
		</div>
	)
}

export default TextArea
